var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 2.25H8.26172C7.85156 1.16602 6.82617 0.375 5.625 0.375C4.39453 0.375 3.36914 1.16602 2.95898 2.25H1.40625C0.615234 2.25 0 2.89453 0 3.65625V13.9688C0 14.7598 0.615234 15.375 1.40625 15.375H9.84375C10.6055 15.375 11.25 14.7598 11.25 13.9688V3.65625C11.25 2.89453 10.6055 2.25 9.84375 2.25ZM5.625 2.25C6.12305 2.25 6.5625 2.68945 6.5625 3.1875C6.5625 3.71484 6.12305 4.125 5.625 4.125C5.09766 4.125 4.6875 3.71484 4.6875 3.1875C4.6875 2.68945 5.09766 2.25 5.625 2.25ZM8.4375 10.2188C8.4375 10.4824 8.20312 10.6875 7.96875 10.6875H6.5625V12.0938C6.5625 12.3574 6.32812 12.5625 6.09375 12.5625H5.15625C4.89258 12.5625 4.6875 12.3574 4.6875 12.0938V10.6875H3.28125C3.01758 10.6875 2.8125 10.4824 2.8125 10.2188V9.28125C2.8125 9.04688 3.01758 8.8125 3.28125 8.8125H4.6875V7.40625C4.6875 7.17188 4.89258 6.9375 5.15625 6.9375H6.09375C6.32812 6.9375 6.5625 7.17188 6.5625 7.40625V8.8125H7.96875C8.20312 8.8125 8.4375 9.04688 8.4375 9.28125V10.2188Z",
    fill: "#AAB0B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.07617f7c.svg";
export { ForwardRef as ReactComponent };